import $ from 'jquery'
import gsap from 'gsap'

/**
 * Slick assigns role="tabpanel" to slides when dots are enabled, but only
 * sets aria-describedby (a description). Tabpanels need an accessible name.
 * Slick fires `init` *before* initADA(), so we also run on the next frame
 * and on afterChange (initADA runs again there).
 */
function nameHeroTabpanels($slider) {
  $slider.find('.slick-slide').each(function () {
    const $slide = $(this)
    const $title = $slide.find('.hero__title').first()
    const titleText = $title.text().replace(/\s+/g, ' ').trim()
    if (titleText) {
      $slide.attr('aria-label', titleText)
      return
    }

    const describedBy = $slide.attr('aria-describedby')
    if (describedBy && document.getElementById(describedBy)) {
      $slide.attr('aria-labelledby', describedBy)
      return
    }

    const index = parseInt($slide.attr('data-slick-index'), 10)
    $slide.attr('aria-label', `Hero slide ${Number.isNaN(index) || index < 0 ? 1 : index + 1}`)
  })
}

function loadHero() {
  if ($('.js-hero-slider').length) {
    $('.js-hero-slider')
      .on('init reInit afterChange', function () {
        const $slider = $(this)
        nameHeroTabpanels($slider)
        window.requestAnimationFrame(function () {
          nameHeroTabpanels($slider)
        })
      })
      .slick({
        arrows: false,
        dots: true,
        autoplay: true,
        speed: 2000,
        fade: true
      })
  }

  gsap.to(".hero", {
    duration: 0.3,
    y: 0,
    autoAlpha: 1,
    opacity: 1,
    ease: "power1.out",
    delay: 0.2,
    overwrite: 'auto'
  })
}

$(document).ready( loadHero );
